<template>
	<div class="coming-soon-container desktop-center">
		<div class="coming-soon-business-banner" :style="businessBanner"></div>
		<div class="coming-soon-inner-content">
			<div class="sk-widget sk-widget-coming-soon-description">
				<div>
					<h1>Coming Soon to {{ businessName }}</h1>
					{{ businessName }} has partnered with 2ndKitchen to bring
					you an unique dining experience. Join the community to enjoy
					access to excellent food, perks, and exclusive events!
				</div>
			</div>
			<div class="sk-widget">
				<div class="sk-widget-coming-soon-perks">
					<img src="/images/2k-menu.png" alt="Dining Options" />
					<div>
						<h2>Exclusive Dining Options</h2>
						<div>
							Choose from specialy curated menus provided by local
							restaurants
						</div>
					</div>
				</div>
			</div>
			<div class="sk-widget">
				<div class="sk-widget-coming-soon-perks">
					<img src="/images/2k-delivery.png" alt="No Delivery Fees" />
					<div>
						<h2>No Delivery Fees</h2>
						<div>
							Enjoy zero delivery fees with safe, contactless,
							delivery
						</div>
					</div>
				</div>
			</div>
			<div class="sk-widget">
				<div class="sk-widget-coming-soon-perks">
					<img src="/images/2k-coupon.png" alt="Earn Rewards" />
					<div>
						<h2>Earn Rewards</h2>
						<div>
							Earn rewards with every order placed when you
							activate your account
						</div>
					</div>
				</div>
			</div>
		</div>
		<button
			v-if="showActivateButton"
			class="button button-primary"
			@click="activateButtonClicked"
		>
			Activate My Amenity
		</button>
	</div>
</template>

<style scoped>
div.coming-soon-container.desktop-center {
	max-width: 700px !important;
}

.coming-soon-business-banner {
	width: 100%;
	height: 200px;
	border-radius: 5px;
	margin-top: 15px;
	margin-bottom: -40px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}

.coming-soon-inner-content {
	margin: 0 25px;
}

.sk-widget-coming-soon-description {
	margin-bottom: 44px;
}

.sk-widget-coming-soon-description > div {
	padding: 20px 30px;
	font-size: 12px;
	color: var(--sk-grey3);
}

.sk-widget-coming-soon-description h1 {
	font-size: 18px;
	font-weight: 600;
	color: var(--gR-base-80);
}

.sk-widget-coming-soon-perks {
	display: flex;
	align-items: center;
}

.sk-widget-coming-soon-perks img {
	width: 75px;
	height: 75px;
	margin-right: 20px;
}

.sk-widget-coming-soon-perks h2 {
	font-size: 14px;
	font-weight: 600;
	color: var(--gR-base-80);
}

.sk-widget-coming-soon-perks div {
	font-size: 12px;
	color: var(--sk-grey3);
}

.button-primary {
	max-width: 325px;
	margin: 30px auto 0 auto;
}

@media (max-width: 700px) {
	.coming-soon-container {
		padding-bottom: 70px;
	}

	.coming-soon-inner-content {
		margin: 0 10px;
	}

	.coming-soon-business-banner {
		margin-top: 0;
		border-radius: 0;
	}

	.button-primary {
		max-width: 300px;
		position: fixed;
		bottom: 10px;
		left: 0;
		left: calc(50% - (300px / 2));
	}
}
</style>

<script>
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
export default {
	name: "ResidentialComingSoonSection",
	computed: {
		businessName() {
			return this.$store.state.business && this.$store.state.business.name
				? this.$store.state.business.name
				: ""
		},
		businessBanner() {
			let imgNameFull = this.$store.state.business.img
			if (!imgNameFull) {
				return ""
			}
			let file =
				process.env.VUE_APP_BASE_IMAGE_URL +
				this.$route.params.slug +
				"/" +
				this.$store.state.business.img
			return {
				backgroundImage: `url(${file})`
			}
		},
		showActivateButton() {
			return (
				!this.$store.state.user ||
				(this.$store.state.user.id == 0 &&
					!this.$store.state.user.isVerified)
			)
		}
	},
	methods: {
		activateButtonClicked() {
			eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW)
		}
	}
}
</script>